export const USER = 'User';

export const PARTNER_ADMIN = 'PartnerAdmin';

export const FIRST_ADMIN = 'FirstAdmin'